import { useCallback, useState } from 'react';
import { calculateSpotlightLauncherWidth } from 'conversations-visitor-experience-components/widget-dimensions/calculateSpotlightLauncherWidth';
import SpotlightWelcomeMessagePopup from './SpotlightWelcomeMessagePopup';
import { useAppDispatch, useAppSelector } from '../../buildStore';
import { getShowSpotlightWelcomeMessagePopup } from './selectors/getShowSpotlightWelcomeMessagePopup';
import { getInitialMessageForWelcomePage } from '../../selectors/widgetDataSelectors/getInitialMessageForWelcomePage';
import { getResponderDisplayData } from '../../responders/selectors/getResponderDisplayData';
import { dismissWelcomeMessagePopup } from './reducers/spotlightWelcomeMessagePopupSlice';
import { jsx as _jsx } from "react/jsx-runtime";
const SpotlightWelcomeMessagePopupContainer = ({
  onOpen,
  browserWindowWidth
}) => {
  const dispatch = useAppDispatch();
  const showPopup = useAppSelector(getShowSpotlightWelcomeMessagePopup);
  const messageText = useAppSelector(getInitialMessageForWelcomePage);
  const agentData = useAppSelector(getResponderDisplayData);
  const [isDismissing, setIsDismissing] = useState(false);
  const handleDismiss = useCallback(() => {
    setIsDismissing(true);
  }, []);
  const handleDismissAnimationEnd = useCallback(() => {
    setIsDismissing(false);
    dispatch(dismissWelcomeMessagePopup());
  }, [dispatch]);
  const handleOpen = useCallback(() => {
    dispatch(dismissWelcomeMessagePopup());
    onOpen();
  }, [dispatch, onOpen]);

  // Keep the card mounted through its exit animation even if `showPopup`
  // flips false mid-animation (e.g. the incoming-message preview popup
  // preempts it) — otherwise onDismissAnimationEnd never fires, the popup
  // never actually commits its dismissal in the slice, and it can
  // resurrect once the preview popup goes away again.
  if (!messageText || !showPopup && !isDismissing) return null;
  return /*#__PURE__*/_jsx(SpotlightWelcomeMessagePopup, Object.assign({}, agentData, {
    messageText: messageText,
    isDismissing: isDismissing,
    width: calculateSpotlightLauncherWidth(browserWindowWidth, false),
    onDismiss: handleDismiss,
    onDismissAnimationEnd: handleDismissAnimationEnd,
    onOpen: handleOpen
  }));
};
SpotlightWelcomeMessagePopupContainer.displayName = 'SpotlightWelcomeMessagePopupContainer';
export default SpotlightWelcomeMessagePopupContainer;